module.exports = __webpack_public_path__ + "img/ad-contact-lg.d823997f.jpg";